angular.module('study.dashboard')
    .component('queriesDistributionReportSummary', {
        templateUrl: 'modules/dashboard/components/queries-distribution-report-summary/template.html',
        bindings: {
            hideFooter: '<',
        },
        controller: [
            'ShareCrfSDK',
            'ShareCrfApiErrorCodes',
            'CrfService',
            'gettextCatalog',
            '$q',
            function(ShareCrfSDK, ShareCrfApiErrorCodes, CrfService, gettextCatalog, $q) {
                var vm = this;

                vm.$onInit = function() {
                    loadData();
                };

                function loadData() {
                    vm.loading = true;

                    return $q.resolve()
                        .then(function() {
                            return ShareCrfSDK.dashboard.queriesDistributionSummary();
                        })
                        .then(function(response) {
                            vm.data = response;
                        }).catch(function(error) {
                            vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);

                            throw error;
                        }).finally(function() {
                            vm.loading = false;
                        });
                }

                vm.elementName = function(elementId) {
                    var element = CrfService.getElement(elementId);

                    return element
                        ? element.getFullLabel().join(' > ')
                        : gettextCatalog.getString('Elemento no disponible');
                };

                vm.percentage = function(value) {

                    return vm.data.totalQueries > 0
                        ? value / vm.data.totalQueries * 100
                        : 0;
                };
            },
        ],
    });